import React, { useEffect, useRef } from 'react';
import SvgXIcon from '../svg/XIcon';
import { Link } from 'react-router-dom';

/**
 *
 * @param {boolean} canClose - Boolean determining if the modal can be closed by the user
 * @param {string} rootUrl - url that all links will direct to when used
 * @param {boolean} useFunction - use a function instead of a link when clicking the cancel button
 * @param {function} onClick - function to use when clicking the cancel button
 */
function Overlay(props) {
  const {
    rootUrl: baseRootUrl,
    onClick,
    canClose,
    useFunction,
    children,
    'data-test': dataTest,
  } = props;

  useEffect(() => {
    document.body.style.height = '100vh';
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.height = 'auto';
      document.body.style.overflow = 'visible';
    };
  }, []); // eslint-disable-line

  const node = useRef();
  let rootUrl = '/';
  if (baseRootUrl) {
    rootUrl = baseRootUrl;
  }

  const displayClose = () => {
    if (canClose) {
      if (useFunction) {
        return (
          <div className="text-large close-window-icon-button no-margin">
            <SvgXIcon onClick={onClick} data-test="close-icon-function" />
          </div>
        );
      } else {
        return (
          <div className="close-window-icon-container">
            <Link
              className="text-large close-window-icon-button no-margin"
              data-test="overlay-close-link"
              to={rootUrl}>
              <SvgXIcon />
            </Link>
          </div>
        );
      }
    }
  };

  return (
    <div className="overlay__background">
      <div
        className="overlay__container"
        ref={node}
        data-test={dataTest || "overlay-container"}>
        {displayClose()}
        {children}
      </div>
    </div>
  );
}

export default Overlay;
